import Axios from 'axios'
import { getCookie } from '../utils/auth-utils'

const generalData = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.API_URL
    return AxiosInstance
  },
  getGeneralData() {
    return this.axios().get(`/leia/entity/${getCookie('profile').id_laboratory}`)
  },
  getContacts() {
    return this.axios().get(`/leia/entity/contacts/${getCookie('profile').id_laboratory}`)
  },
  getCities(uf) {
    return this.axios().get(`/leia/city/${uf}`)
  },
  updateGeneralData(generalData) {
    let formatedGeneralData = generalData
    formatedGeneralData['address'] = generalData.addresses[0]
    return this.axios().put(`/leia/entity/${getCookie('profile').id_laboratory}`, formatedGeneralData)
  },
  updateContacts(contactsPayload) {
    return this.axios().put(`/leia/entity/contacts/${getCookie('profile').id_laboratory}`, contactsPayload)
  }
}

export default generalData
